import { Component, OnInit } from '@angular/core';
import { ElectService } from '../service/elect.service';
import { Router, NavigationExtras } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

	noData = [];
  disableVoting: boolean;
  disableRegister: boolean;


  constructor(private els: ElectService, public router: Router) { }

  ngOnInit(): void {
  	this.els.getNo().subscribe(data => {
  		this.noData = data;
  	});
  
    const sdate = new Date("2020/12/14 00:00:01").getTime();
    const edate = new Date("2020/12/16 11:59:59").getTime();
    const ndate = new Date().getTime();

    if(ndate < sdate){
      this.disableVoting = true;
      this.disableRegister = false;
    }else if(ndate > sdate && ndate < edate){
      this.disableVoting = false;
      this.disableRegister = false;
    }else if(ndate > edate){
      this.disableVoting = true;
      this.disableRegister = true;
    }
  }
  register(){
    this.router.navigate(['voterreg']);

  }
  login(){
    this.router.navigate(['login']);
  }



}
